import { fromStringToE164, fromE164ToDisplay } from '@united-talent-agency/components';

export function formatContact(type, contact) {
  if (type && contact) {
    if (type === 'Email' || contact.includes('@')) {
      return contact;
    }
    contact = contact.replace(/[^\d]/g, '');
    if (contact.length === 4) {
      return 'x' + contact;
    } else if (contact.length === 10) {
      return contact.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    } else if (contact.length === 11) {
      return contact.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '+$1 ($2) $3-$4');
    } else {
      return contact;
    }
  }
}

export const contactTypes = {
  'Office Phone': 'Work',
  'Home Phone': 'Home',
  'Mobile Phone': 'Mobile',
  'Assistant Phone': 'Asst. Phone',
  'Assistant Email': 'Asst. Email',
  'Fax Number': 'Fax',
  Email: 'Email',
  Message: 'Message',
  Unknown: 'Misc.',
};

export const existingContactNotPhone = (person, contact) => {
  if (!contact || !person || !person.contacts) {
    return false;
  }

  return person.contacts.find(
    (spc) =>
      contact.contact &&
      spc.contact &&
      contact.contact.trim().toLowerCase() === spc.contact.trim().toLowerCase()
  );
};

export const existingContactPhone = (person, contact) => {
  if (!contact || !person || !person.contacts) {
    return false;
  }

  const digits = contact.contact?.replace(/[^0-9]/g, '');
  return person.contacts.find((spc) => {
    const spcDigits = spc.contact?.replace(/[^0-9]/g, '');
    const regexTest = `^(\\d{1,3})?${spcDigits}$`;
    const spcDigitsRegex = new RegExp(regexTest);
    return (
      /Phone|Fax Number/.test(spc.contactType) && spcDigits?.length && spcDigitsRegex.test(digits)
    );
  });
};

export const formatContactForDisplay = (unformattedContact) => {
  const userRegion = navigator.language.split('-')[1];
  const formattedContact = Object.assign({}, unformattedContact);
  unformattedContact &&
    unformattedContact.contact &&
    /Phone|Fax Number/.test(unformattedContact.contactType) &&
    (formattedContact.contact = fromE164ToDisplay(
      fromStringToE164(unformattedContact.contact),
      userRegion,
      ' x'
    ));
  return formattedContact || '';
};

const CONTACT_PRIORITIES = [
  'Office Phone',
  'Assistant Phone',
  'Mobile Phone',
  'Home Phone',
  'Email',
  'Assistant Email',
  'Personal Email',
  'Message',
  'Fax Number',
  'Unknown',
];

/************************************************************
 *         Get Primary Contact from contacts array          *
 * -------------------------------------------------------- *
 *  1. If there are multiple Primary set, the order is:     *
 *     Phone > Email > Other                                *
 *  2. If no priority contact exists, then order will be:   *
 *     Work > Assistant Phone > Mobile > Home > Email >     *
 *     Assistant email > Personal Email > Message > Fax     *
 ************************************************************/
export const getPrimaryContact = (contacts) => {
  let primaryContact = null;
  if (contacts) {
    const primaryContacts = contacts.filter((c) => c.primary);

    if (primaryContacts.length > 0) {
      // has primary contacts
      CONTACT_PRIORITIES.forEach((contactType) => {
        const contact = primaryContacts.find((c) => c.contactType === contactType);
        if (contact && !primaryContact) {
          primaryContact = { ...contact };
          return;
        }
      });
    } else {
      // no primary contacts
      CONTACT_PRIORITIES.forEach((contactType) => {
        const contact = contacts.find((c) => c.contactType === contactType);
        if (contact && !primaryContact) {
          primaryContact = { ...contact };
          return;
        }
      });
    }
  }

  return primaryContact || {};
};
